import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class AssetRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allAssets() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/assets`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/assets`, {headers: headers});
    }

    allAssetsOfUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/assets/user/${store.state.user.id}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    allAssetsOfExternalUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/assets/user/${userId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    assetsByMarket(market) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/assets/market/${market}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/assets/market/${market}`, {headers: headers});
    }

    addAsset(assetId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/assets/add?userId=${store.state.user.id}&assetId=${assetId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/assets/add?userId=${store.state.user.id}&assetId=${assetId}`, {headers: headers});
    }

    deleteAssetToUserWatchlist(assetId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/assets?userId=${store.state.user.id}&assetId=${assetId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.delete(`${this.basePath}/ext/assets?userId=${store.state.user.id}&assetId=${assetId}`, {headers: headers});
    }
}

export default new AssetRepository();
